export default "__VITE_ASSET__CmW8VQ0B__"